import { ref } from 'vue';
import { session } from './session';

export const showDebug = ref(Boolean(session.account?.is_staff));
